import { ellipsis, hideVisually } from "polished";
import styled from "styled-components";

export const Ellipsis = styled.div`
  ${ellipsis()}
  vertical-align: middle;
`;

export const UnstyledButton = styled.button`
  display: block;
  width: 100%;
  padding: 0;
  border: 0;
  background-color: transparent;
  font-family: ${({ theme }) => theme.fonts.base};
  line-height: 1;
  cursor: pointer;
`;

export const VisuallyHidden = styled.span`
  ${hideVisually}
`;

const FetchAPI = async (
  uri: string,
  data: Record<string, string>,
  method: string,
  custoHeaders: Record<string, string>,
) => {
  return fetch(`/api/${uri}`, {
    method,
    credentials: "same-origin",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...custoHeaders,
    },
    body: method === "GET" ? undefined : JSON.stringify(data),
  }).then((response) => {
    if (!response.ok) {
      // create error object and reject if not a 2xx response code
      throw response;
    }
    return response;
  });
};

export const FetchGet = async (
  uri: string,
  data: Record<string, string>,
  custoHeaders: Record<string, string>,
) => FetchAPI(uri, data, "GET", custoHeaders);
